module.exports = __webpack_public_path__ + "static/media/veg-ravioli.2a10e5ae.jpg";